import { Alert as RNAlert, Platform } from 'react-native';
import type { AlertButton, AlertOptions } from 'react-native';

// Store a reference to our custom Alert function
let customAlertFunction: typeof RNAlert.alert | null = null;

// Method to be called by the provider to set the custom alert implementation
export const setCustomAlertImplementation = (
	alertFn: typeof RNAlert.alert,
) => {
	customAlertFunction = alertFn;
};

// Enhanced Alert object with new notification methods
export const Alert = {
	// Original Alert.alert method - maintains backward compatibility
	alert: (
		title: string,
		message?: string,
		buttons?: AlertButton[],
		options?: AlertOptions,
	): void => {
		// If we're on web and have a custom implementation, use it
		if (Platform.OS === 'web' && customAlertFunction) {
			customAlertFunction(title, message, buttons, options);
		} else {
			// Fall back to the native Alert
			RNAlert.alert(title, message, buttons, options);
		}
	},

	// New enhanced methods for direct notification access
	showToast: (message: string, options?: any) => {
		// This will be implemented when we integrate with the notification context
		// For now, fall back to alert
		Alert.alert('', message, [{ text: 'OK' }]);
	},

	showModal: (title: string, message?: string, actions?: any[]) => {
		// This will be implemented when we integrate with the notification context
		// For now, fall back to alert
		const buttons: AlertButton[] = actions?.map(action => ({
			text: action.label,
			onPress: action.onPress,
			style: action.style === 'destructive' ? 'destructive' : 'default',
		})) || [{ text: 'OK' }];

		Alert.alert(title, message, buttons);
	},

	showBanner: (message: string, variant?: 'success' | 'error' | 'warning' | 'info') => {
		// This will be implemented when we integrate with the notification context
		// For now, fall back to alert
		Alert.alert('', message, [{ text: 'Dismiss' }]);
	},
};
